import BaseStore from "@/stateManagement/BaseStore";
import { AttributesFiltersEntity } from "@apps/reviews/entities/AttributesFiltersEntity";
import { StoreConfig } from "@datorama/akita";
import { produce } from "immer";
import { injectable } from "tsyringe";

export type ReviewsFilterState = {
    data: AttributesFiltersEntity;
    isFilter: boolean;
};

export function createInitialState(): ReviewsFilterState {
    return {
        data: {
            customerFilters: [],
            productFilters: [],
        },
        isFilter: false,
    };
}

@injectable()
@StoreConfig({ name: "review_filter_store", producerFn: produce })
class ReviewsFilterStore extends BaseStore<ReviewsFilterState> {
    constructor() {
        super(createInitialState());
    }
}

export default ReviewsFilterStore;
